import { ApiService } from './api/api'
import type { CollectionItem } from '@/data/schema/collection-item'
import { paramsToQueryString } from '@/utils/params'

export default class CollectionService {
	private apiService

	constructor() {
		this.apiService = new ApiService(true)
	}

	/**
	 * Get a collection record by ID
	 * @param id string - collection number
	 * @param params Object
	 * @returns Promise
	 */
	get(id: string, params: Object): Promise<any> {
		return this.apiService.get(`/collections/${id}`, {
			params: params
		})
	}

	/**
	 * Update Collection
	 * @param collection_number string
	 * @param params Object
	 * @returns
	 */
	updateCollection(collection_number: string, params: Object): Promise<any> {
		return this.apiService.patch(`/collections/${collection_number}`, params)
	}

	/**
	 * Bulk update collection items
	 * @param items
	 * @param urlParams
	 * @returns
	 */
	updateItems(items: CollectionItem[], urlParams?: Object): Promise<any> {
		const query = paramsToQueryString(urlParams)

		return this.apiService.patch(`/collection-items/bulk-update${query}`, {
			items: items
		})
	}
}
